import React from 'react'
import { Image } from 'semantic-ui-react';
import PlaceholderCardImage from './../../../../drive/PlaceHolder/PlaceHolderLoading'
import cupOnTrack from "../../../../../images/common/cup_onTrack.png";
import cupDelayed from "../../../../../images/common/cup_delayed.png";
import cupIssue from "../../../../../images/common/cup_issue.png";
import EllipsisTooltip from './../../../../common/EllipsisTooltip'

class CupCard extends React.Component {

    goToMyProgress = () => {
        this.props.history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_at/myactivities`)
    }

    render() {
        let status = this.props.intitiativeCountData;

        return (
            !this.props.loaderDashboard ?
                <div className="cupCard">
                    <div className="cupImage">
                        <Image src={status.issue !== 0 ?
                            cupIssue : status.delayed !== 0 ?
                                cupDelayed : cupOnTrack} />
                    </div>
                    <div className={` ${status.issue === 0 && status.delayed === 0 ? "cupTextOntrack" : "cupText"} `}>
                            <label>
                                <EllipsisTooltip name={`Welcome ${this.props.user.firstName}`} />
                            </label> 
                        
                        <span> {status.issue !== 0 ?
                            <span>
                                Some Activities have an  {' '}
                                <span className=" cursor-pointer hov-clr-red text-underline" onClick={this.goToMyProgress}>Issue</span>
                            </span> :
                            status.delayed !== 0 ?
                                <span>
                                    Some Activities are  {' '}
                                    <span className="cursor-pointer hov-clr-yellow text-underline" onClick={this.goToMyProgress}>Delayed</span>
                                </span>
                                : ''
                            // <span>
                            //     Everything seems to be {' '}
                            //     <span className=" cursor-pointer hov-clr-blue text-underline" onClick={this.goToMyProgress}>On Track</span>
                            // </span>
                        }</span>
                    </div>
                </div>
                : <PlaceholderCardImage />
        )
    }
}

export default CupCard;